import { TableHeadersType } from "../tableHeadersType";

export const GSTR_3B_ACCORDIAN_HEADERS = [
  {
    header:
      "3.1 Details of Outward supplies and inward supplies liable to reverse charge",
    isOpen: false,
    id: 1,
    data: [
      {
        natureOfSupplies:
          "(a) Outward taxable supplies (other than zero rated, nil rated and exempted)",
      },
      {
        natureOfSupplies: "(b) Outward taxable supplies (zero rated)",
      },
      {
        natureOfSupplies: "(c) Other outward supplies (nil rated, exempted)",
      },
      {
        natureOfSupplies: "(d) Inward supplies (liable to reverse charge)",
      },
      {
        natureOfSupplies: "(e) Non-GST outward supplies",
      },
    ],
  },
  {
    header:
      "3.1.1 Details of Supplies notified under section 9(5) of the CGST Act, 2017 and corresponding provisions in IGST/UTGST/ SGST Acts",
    isOpen: false,
    id: 2,
    data: [
      {
        natureOfSupplies:
          "Taxable supplies on which electronic commerce operator pays tax u/s 9(5) [to be furnished by electronic commerce operator] ",
      },
      {
        natureOfSupplies:
          "Taxable supplies made by registered person through electronic commerce operator, on which electronic commerce operator is required to pay tax u/s 9(5) [to be furnished by registered person making supplies through electronic commerce operator]",
      },
    ],
  },
  {
    header:
      "3.2 Out of supplies made in 3.1 (a) and 3.1.1 (i), details of inter-state supplies made",
    isOpen: false,
    id: 3,
    data: [
      {
        natureOfSupplies: "Supplies made to unregistered Persons",
      },
      {
        natureOfSupplies: "Supplies made to Composition Taxable Persons",
      },
      {
        natureOfSupplies: "Supplies made to UIN holders",
      },
    ],
  },
  {
    header: "4. Eligible ITC",
    isOpen: false,
    id: 4,
  },
  {
    header: "5. Values of exempt, nil-rated and non-GST inward supplies",
    isOpen: false,
    id: 5,
  },
  {
    header: "5.1 Interest and Late fee for previous tax period",
    isOpen: false,
    id: 6,
  },
  {
    header: "6.1 Payment of tax",
    isOpen: false,
    id: 7,
  },
  {
    header: "Breakup of tax liability declared (for interest computation)",
    isOpen: false,
    id: 8,
  },
];

export const getGstrThreeBDataTemplate = (
  gstrThreeBData: any,
  gstrThreeBInvoiceList: any,
  header: string
) => {
  switch (header) {
    case "3.1 Details of Outward supplies and inward supplies liable to reverse charge":
      return {
        data: [
          {
            natureOfSupplies:
              "(a) Outward taxable supplies (other than zero rated, nil rated and exempted)",
            tableRowData: gstrThreeBData?.gstr3b_3_1?.a,
            isSource: true,
            sourceData: gstrThreeBInvoiceList?.gstr3b_3_1?.a
              ? gstrThreeBInvoiceList?.gstr3b_3_1?.a
              : [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "(b) Outward taxable supplies (zero rated)",
            tableRowData: gstrThreeBData?.gstr3b_3_1?.b,
            isSource: true,
            sourceData: gstrThreeBInvoiceList?.gstr3b_3_1?.b
              ? gstrThreeBInvoiceList?.gstr3b_3_1?.b
              : [],
            showViewSource: false,
          },
          {
            natureOfSupplies:
              "(c) Other outward supplies (nil rated, exempted)",
            tableRowData: gstrThreeBData?.gstr3b_3_1?.c,
            isSource: true,
            sourceData: gstrThreeBInvoiceList?.gstr3b_3_1?.c,
            showViewSource: false,
          },
          {
            natureOfSupplies: "(d) Inward supplies (liable to reverse charge)",
            tableRowData: gstrThreeBData?.gstr3b_3_1?.d,
            isSource: true,
            sourceData: gstrThreeBInvoiceList?.gstr3b_3_1?.d,
            showViewSource: false,
          },
          {
            natureOfSupplies: "(e) Non-GST outward supplies",
            tableRowData: gstrThreeBData?.gstr3b_3_1?.e,
            isSource: true,
            sourceData: gstrThreeBInvoiceList?.gstr3b_3_1?.e,
            showViewSource: false,
          },
        ],
      };
    case "3.1.1 Details of Supplies notified under section 9(5) of the CGST Act, 2017 and corresponding provisions in IGST/UTGST/ SGST Acts":
      return {
        data: [
          {
            natureOfSupplies:
              "Taxable supplies on which electronic commerce operator pays tax u/s 9(5) [to be furnished by electronic commerce operator] ",
            tableRowData:
              gstrThreeBData?.gstr3b_3_1_1
                ?.electronic_commerce_operator_payment,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies:
              "Taxable supplies made by registered person through electronic commerce operator, on which electronic commerce operator is required to pay tax u/s 9(5) [to be furnished by registered person making supplies through electronic commerce operator]",
            tableRowData:
              gstrThreeBData?.gstr3b_3_1_1
                ?.electronic_commerce_operator_payment_by_registered_person,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
        ],
      };
    case "3.2 Out of supplies made in 3.1 (a) and 3.1.1 (i), details of inter-state supplies made":
      return {
        data: [
          {
            natureOfSupplies: "Supplies made to unregistered Persons",
            tableRowData: gstrThreeBData?.gstr3b_3_2?.unregistered_persons_data,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "Supplies made to Composition Taxable Persons",
            tableRowData:
              gstrThreeBData?.gstr3b_3_2?.composition_taxable_persons_data,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "Supplies made to UIN holders",
            tableRowData: gstrThreeBData?.gstr3b_3_2?.a,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
        ],
      };
    case "4. Eligible ITC":
      return {
        data: [
          {
            natureOfSupplies: "A. ITC Available (Whether in full or part)",
            tableRowData: "",
            fullLength: true,
          },
          {
            natureOfSupplies: "(1) Import of goods",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4A?.import_of_goods,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "(2) Import of services",
            tableRowData:
              gstrThreeBData?.gstr3b_4?.gstr3b_4A?.import_of_services,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies:
              "(3) Inward supplies liable to reverse charge (other than 1 & 2 above)",
            tableRowData:
              gstrThreeBData?.gstr3b_4?.gstr3b_4A?.liable_to_reverse_charge,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "(4) Inward supplies from ISD",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4A?.isd,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "(5) all other ITC",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4A?.others,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "B. ITC Reversed",
            tableRowData: "",
            fullLength: true,
          },
          {
            natureOfSupplies:
              "As per rules 38,42 & 43 of CGST Rules and section 17(5)",
            tableRowData:
              gstrThreeBData?.gstr3b_4?.gstr3b_4B?.as_per_cgst_rules,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "(2) Others",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4B?.others,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "C. Net ITC available (A-B)",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4C,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "D. Other Details",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4D,
            fullLength: true,
          },
          {
            natureOfSupplies:
              "(1) ITC reclaimed which was reversed under Table 4(B)(2) in earlier tax period",
            tableRowData:
              gstrThreeBData?.gstr3b_4?.gstr3b_4D?.as_per_section_17,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies:
              "(2) Ineligible ITC under section 16(4) & ITC restricted due to PoS rules",
            tableRowData: gstrThreeBData?.gstr3b_4?.gstr3b_4D?.others,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
        ],
      };
    case "5. Values of exempt, nil-rated and non-GST inward supplies":
      return {
        data: [
          {
            natureOfSupplies:
              "From a supplier under composition scheme, Exempt, Nil rated supply",
            tableRowData: gstrThreeBData?.gstr3b_5?.nil_rated_supply,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
          {
            natureOfSupplies: "Non GST Supply",
            tableRowData: gstrThreeBData?.gstr3b_5?.non_gst_supply,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
        ],
      };
    case "5.1 Interest and Late fee for previous tax period":
      return {
        data: [
          {
            natureOfSupplies: "System computed Interest",
            tableRowData: gstrThreeBData?.gstr3b_5_1,
          },
          {
            natureOfSupplies: "Interest Paid",
            tableRowData: gstrThreeBData?.gstr3b_5_1,
          },
          {
            natureOfSupplies: "Late Fee",
            tableRowData: gstrThreeBData?.gstr3b_5_1,
          },
        ],
      };
    case "6.1 Payment of tax":
      return {
        data: [
          {
            natureOfSupplies: "(A) Other than reverse charge",
            tableRowData: "",
            fullLength: true,
          },
          {
            natureOfSupplies: "Integrated tax",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.other_than_reverse_charge
                ?.integrated_tax,
          },
          {
            natureOfSupplies: "Central tax",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.other_than_reverse_charge
                ?.central_tax,
          },
          {
            natureOfSupplies: "State/UT tax",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.other_than_reverse_charge?.state_tax,
          },
          {
            natureOfSupplies: "CESS",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.other_than_reverse_charge?.cess,
          },
          {
            natureOfSupplies: "(B) reverse charge",
            tableRowData: gstrThreeBData?.gstr3b_6_1?.reverse_charge,
            fullLength: true,
          },
          {
            natureOfSupplies: "Integrated tax",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.reverse_charge?.integrated_tax,
          },
          {
            natureOfSupplies: "Central tax",
            tableRowData:
              gstrThreeBData?.gstr3b_6_1?.reverse_charge?.central_tax,
          },
          {
            natureOfSupplies: "State/UT tax",
            tableRowData: gstrThreeBData?.gstr3b_6_1?.reverse_charge?.state_tax,
          },
          {
            natureOfSupplies: "CESS",
            tableRowData: gstrThreeBData?.gstr3b_6_1?.reverse_charge?.cess,
          },
        ],
      };
    case "Breakup of tax liability declared (for interest computation)":
      return {
        data: [
          {
            natureOfSupplies: "January 2022",
            tableRowData: gstrThreeBData?.breaku_of_tax_liability_declared,
            isSource: true,
            sourceData: [],
            showViewSource: false,
          },
        ],
      };
    default:
      return {
        data: [
          {
            natureOfSupplies:
              "(a) Outward taxable supplies (other than zero rated, nil rated and exempted)",
          },
          {
            natureOfSupplies: "(b) Outward taxable supplies (zero rated)",
          },
          {
            natureOfSupplies:
              "(c) Other outward supplies (nil rated, exempted)",
          },
          {
            natureOfSupplies: "(d) Inward supplies (liable to reverse charge)",
          },
          {
            natureOfSupplies: "(e) Non-GST outward supplies",
          },
        ],
      };
  }
};

export const GSTR_THREEB_INVOICE_HEADER: TableHeadersType[] = [
  {
    label: "Name",
    value: "name",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice No.",
    value: "invoice_no",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Invoice Date",
    value: "invoice_date",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Document Type",
    value: "document_type",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Total Amount",
    value: "total_amount",
    defaultChecked: true,
    checked: true,
  },
  // {
  //   label: "Attachments",
  //   value: "attachments",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Added/Modified by",
  //   value: "added_modified_by",
  //   defaultChecked: true,
  //   checked: true,
  // },
  // {
  //   label: "Status",
  //   value: "status",
  //   defaultChecked: true,
  //   checked: true,
  // },
];

export const GSTR_3B_THREE_POINT_ONE_HEADERS = [
  {
    label: "Nature of supplies",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Total taxable value",
    value: "total_taxable_value",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Integrated Tax",
    value: "total_igst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Central Tax",
    value: "total_cgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "STATE/UT TAX",
    value: "total_sgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CESS",
    value: "cess",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_THREE_POINT_TWO_HEADERS = [
  {
    label: "Nature of supplies",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Total taxable value",
    value: "total_taxable_value",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Integrated Tax",
    value: "total_igst_amount",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_FOUR_HEADERS = [
  {
    label: "Details",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Integrated Tax",
    value: "total_igst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Central Tax",
    value: "total_cgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "STATE/UT TAX",
    value: "total_sgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CESS",
    value: "cess",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_FIVE_HEADERS = [
  {
    label: "Nature of supplies",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Inter-State Supplies",
    value: "inter_state_supplies",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Intra-State Supplies",
    value: "intra_state_supplies",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_FIVE_POINT_ONE_HEADERS = [
  {
    label: "Details",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Integrated Tax",
    value: "total_igst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Central Tax",
    value: "total_cgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "STATE/UT TAX",
    value: "state_ut_tax",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CESS",
    value: "cess",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_SIX_POINT_ONE_HEADERS = [
  {
    label: "Description",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  // {
  //   label: "NO. OF RECORDS",
  //   value: "total_count",
  //   defaultChecked: false,
  //   checked: false,
  // },
  {
    label: "Total tax payable",
    value: "total_tax_payable",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Tax paid through ITC",
    value: "tax_paid_through_itc",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Tax paid in cash",
    value: "tax_paid_in_cash",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Interest paid in cash",
    value: "interest_paid_in_cash",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Late fee paid in cash",
    value: "late_fee_paid_in_cash",
    defaultChecked: false,
    checked: false,
  },
];
export const GSTR_3B_BREAKUP_TAX_LIABILITY_DECLARED_HEADERS = [
  {
    label: "Period",
    value: "description",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "NO. OF RECORDS",
    value: "total_count",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Integrated Tax",
    value: "total_igst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "Central Tax",
    value: "total_cgst_amount",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "STATE/UT TAX",
    value: "state_ut_tax",
    defaultChecked: false,
    checked: false,
  },
  {
    label: "CESS",
    value: "cess",
    defaultChecked: false,
    checked: false,
  },
];

export const HSN_SUMMARY_HEADERS=[
  {
    label: "HSN SAC CODE",
    value: "hsn_sac_code",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Quantity",
    value: "total_quantity",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Unit",
    value: "unit",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "GST Rate",
    value: "gst_rate",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Taxable Value",
    value: "total_taxable_value",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "CGST",
    value: "total_cgst",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "SGST",
    value: "total_sgst",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "IGST",
    value: "total_igst",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "COUNT",
    value: "count",
    defaultChecked: true,
    checked: true,
  },
]